import request from "@/utils/request";
export default {
  // 用户注册
  register(username, password, mobile, group_id, inviter_id) {
    return request.post("/api/user/register", {
      username: username,
      password: password,
      mobile: mobile,
      group_id: group_id,
      inviter_id: inviter_id || "",
    });
  },
  // 用户登录
  login(mobile, password) {
    return request.post("/api/user/login", {
      mobile: mobile,
      password: password,
    });
  },
};
